module.exports = __webpack_public_path__ + "static/media/dev-programme.c5a0bb87.png";